export const list = {
  padding: {
    paddingBottom: '0',
    paddingTop: '0',
  },
};
